export const LOGIN_PATHNAME = '/login';
export const LOGGEDIN_PATHNAME = '/loggedin';
export const LOGGEDOUT_PATHNAME = '/loggedout';
export const LOGIN_PATH_LIST = ['/login', '/loggedin', '/loggedout'];
export const LOGIN_AND_LOGGEDOUT_PATH_LIST = ['/login', '/loggedout'];

export const JWEB_SIGNIN_REQUEST_ID = 'CLIENTOS_SIGNIN_REQUEST_ID';

export const JWEB_THRESHOLD_TIME = 30;
export const JWEB_MAX_THRESHOLD_TIME = 35;
